import videojs from 'video.js';
import { getImage, ImageSize } from '../../../../shared/utils/imageFormat';
import { browser } from './detect';
import 'videojs-mux';

require('./video-offset.js');
require('videojs-contrib-quality-levels');

// Disable Video JS analytics
window.HELP_IMPROVE_VIDEOJS = false;

// VOD Editor
const renderVideoVODEditor = (divId) => {
  var playerOptions = {
    fluid: true,
    techCanOverridePoster: false,
    preload: 'none',
    userActions: {
      hotkeys: true,
    },
    controlBar: {
      pictureInPictureToggle: false,
    },
    html5: {
      hlsjsConfig: {
        // Put your hls.js config here
      },
    },
  };

  var player = videojs(divId, playerOptions);
  player.on('error', (e) => {
    console.log('videojs error', e);
  });

  //Remove fullscreen double click
  player.ready(function () {
    player.tech_.off('dblclick');
  });

  player.finish = () => {
    player.dispose();
  };
  return player;
};

// VOD
const renderVideoVOD = (
  divId,
  playbackId,
  jwtToken,
  thumb_jwt,
  videoStart,
  videoDuration
) => {
  var playerOptions = {
    fluid: true,
    poster: thumb_jwt
      ? `https://image.mux.com/${playbackId}/thumbnail.jpg?token=${thumb_jwt}`
      : getImage('/misc/black_shade_bg.jpg', ImageSize.Medium),
    //autoplay: 'muted',
    preload: 'auto',
    userActions: {
      hotkeys: true,
    },
    html5: {
      vhs: {
        // prevent to have a resolution selected higher than
        // the player size. By default this is set to true.
        // We set it to true here to remember this undocumented option.
        limitRenditionByPlayerDimensions: false,
        overrideNative: !videojs.browser.IS_SAFARI,
        // take the device pixel ratio into account when doing rendition switching.
        // This means that if you have a player with the width of 540px in a high density
        // display with a device pixel ratio of 2, a rendition of 1080p will be allowed.
        useDevicePixelRatio: true,
        //When the bandwidth property is set (bits per second), it will be used in the calculation
        //for initial playlist selection, before more bandwidth information is seen by the player.
        //bandwidth: 10000000,
        bandwidth: 10000000,
        experimentalBufferBasedABR: true,
      },
    },
  };

  var player = videojs(divId, playerOptions);
  let qualityLevels = player.qualityLevels();
  //Mux data plugin settings
  player.mux({
    debug: false,
    data: {
      env_key: process.env.MUX_ENV_KEY, //required
      // Metadata
      player_name: 'COEO VOD Player',
      player_init_time: Date.now(),
      video_id: playbackId,
      video_stream_type: 'vod',
    },
  });

  // Listen to change events for when the player selects a new quality level
  qualityLevels.on('change', function () {
    console.log('Quality Level changed!');
    console.log('New level:', qualityLevels[qualityLevels.selectedIndex]);
  });

  player.on('error', (e) => {
    console.log('videojs error', e);
  });

  if (videoStart !== null && videoDuration !== null) {
    player.offset({
      start: videoStart / 1000,
      end: (videoStart + videoDuration) / 1000,
      restart_beginning: false, //Should the video go to the beginning when it ends
    });
  }

  //Remove fullscreen double click
  player.ready(function () {
    player.tech_.off('dblclick');
  });

  player.finish = () => {
    player.dispose();
  };
  return player;
};

const renderVideoLive = (divId, playbackId, jwtToken) => {
  //remember divId cannot start with a number, there is 1 hour of my life gone to waste.
  const playerOptions = {
    src: `//stream.mux.com/${playbackId}.m3u8?token=${jwtToken}`,
    liveui: true,
    liveTracker: true,
    playsInline: true,
    fluid: true,
    trackingThreshold: 2,
    controlBar: {},
    html5: {
      hlsjsConfig: {
        // Put your hls.js config here
        liveSyncDurationCount: 3,
      },
      vhs: {
        // prevent to have a resolution selected higher than
        // the player size. By default this is set to true.
        // We set it to true here to remember this undocumented option.
        limitRenditionByPlayerDimensions: false,
        overrideNative: !videojs.browser.IS_SAFARI,
        // take the device pixel ratio into account when doing rendition switching.
        // This means that if you have a player with the width of 540px in a high density
        // display with a device pixel ratio of 2, a rendition of 1080p will be allowed.
        useDevicePixelRatio: true,
        //When the bandwidth property is set (bits per second), it will be used in the calculation
        //for initial playlist selection, before more bandwidth information is seen by the player.
        //bandwidth: 10000000,
        bandwidth: 10000000,
        experimentalBufferBasedABR: true,
      },
    },
  };

  const initializedCallback = () => {
    // here you can interact with hls.js instance and/or video.js playback is initialized
    if (browser.isChrome) {
      //autoPlay && player.play();
    }
  };

  // setup beforeinitialize hook (not working on iOS)
  if (videojs.Html5Hlsjs) {
    videojs.Html5Hlsjs.addHook('beforeinitialize', initializedCallback);
  }

  var player = videojs(divId, playerOptions);
  let qualityLevels = player.qualityLevels();
  //Mux data plugin settings
  player.mux({
    debug: true,
    data: {
      env_key: process.env.MUX_ENV_KEY, //required
      // Metadata
      player_name: 'COEO LIVE Player',
      player_init_time: Date.now(),
      video_id: playbackId,
      video_stream_type: 'live',
    },
  });

  // Listen to change events for when the player selects a new quality level
  qualityLevels.on('change', function () {
    console.log('Quality Level changed!');
    console.log('New level:', qualityLevels[qualityLevels.selectedIndex]);
  });

  if (window.MediaSource) {
    player.on('error', (e) => {
      console.log('videojs error', e);
    });

    if (!videojs.Html5Hlsjs) {
      // For iOS
      player.ready(initializedCallback);
    }
    player.src(playerOptions.src);
  }

  player.finish = () => {
    videojs.Html5Hlsjs &&
      videojs.Html5Hlsjs.removeHook('beforeinitialize', initializedCallback);
    player.reset();
  };
  return player;
};

export { renderVideoVOD, renderVideoLive, renderVideoVODEditor };
